"use client";

import { Tick } from "@monsterindia/global-ui-components";
import React from "react";

import { BenefitItem } from "../types/unsubscribe";

interface PauseBenefitsProps {
  benefits: BenefitItem[];
  isMobile: boolean;
}

export const PauseBenefits: React.FC<PauseBenefitsProps> = ({
  benefits,
  isMobile,
}) => {
  return (
    <div className="mt-6 rounded-lg bg-[#FFF] px-3 py-2">
      <h3 className="mb-2 text-xs font-medium leading-4 text-[#17142A] md:mb-3">
        Why pause for a few months?
      </h3>
      <ul className="space-y-2">
        {benefits.map((benefit) => (
          <li key={benefit.id} className="flex items-start gap-2">
            <div className="flex items-center md:self-stretch">
              {isMobile ? (
                <div className="mt-2 h-1 w-1 flex-shrink-0 rounded-full bg-[#59566C]"></div>
              ) : (
                <Tick width="11" height="11" />
              )}
            </div>
            <span className="text-xs font-normal leading-4 text-[#17142A]">
              {benefit.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
